/* ==========================================================================
   DS CORE JS v1.2  |  Discreet Smoker homepage behavior
   Upload to: assets/ds-core.js
   Loaded with defer by every DS section that has products. Safe to include
   many times: everything below only sets itself up once.
   - <ds-rail>: desktop arrows for swipe rails, hidden when nothing to scroll
   - Product card swatches: swap image, price and link to the chosen color
   - Video lightbox for promo tiles (nothing loads until tapped)
   - Product card quick add: adds to cart, updates the cart count, then opens
     the theme's cart drawer (falls back gracefully if there isn't one)
   - v1.2: DSCore.addToCart(body) and DSCore.openCart() shared with the
     product page, so every add to cart behaves the same way
   ========================================================================== */
(function () {
  if (window.DSCore) return;
  window.DSCore = { version: 2 };

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Rail arrows ---------- */
  if (!customElements.get('ds-rail')) {
    customElements.define('ds-rail', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.list = this.querySelector('.ds-rail');
        if (!this.list) return;
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');

        var update = function () {
          var max = self.list.scrollWidth - self.list.clientWidth - 2;
          var x = Math.abs(self.list.scrollLeft);
          if (self.prev) self.prev.disabled = x <= 2;
          if (self.next) self.next.disabled = x >= max;
          self.toggleAttribute('data-static', max <= 2);
        };
        var step = function (dir) {
          self.list.scrollBy({ left: dir * self.list.clientWidth * 0.9, behavior: 'smooth' });
        };

        this.list.addEventListener('scroll', function () {
          cancelAnimationFrame(self.raf);
          self.raf = requestAnimationFrame(update);
        }, { passive: true });
        if (this.prev) this.prev.addEventListener('click', function () { step(-1); });
        if (this.next) this.next.addEventListener('click', function () { step(1); });
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(update);
          this.ro.observe(this.list);
        }
        update();
      }
      disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
    });
  }

  /* ---------- Swatches ---------- */
  function pickSwatch(btn) {
    var card = btn.closest('.ds-pc');
    if (!card) return;
    card.querySelectorAll('.ds-sw').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    card.classList.add('is-swatched');

    var img = card.querySelector('.ds-pc__img--main');
    if (img && btn.dataset.img) {
      if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
      img.src = btn.dataset.img;
    }
    var link = card.querySelector('.ds-pc__title a');
    if (link && btn.dataset.url) link.href = btn.dataset.url;

    var price = card.querySelector('.ds-pc__price');
    if (price && btn.dataset.now) {
      var now = price.querySelector('.ds-pc__now');
      var was = price.querySelector('.ds-pc__was');
      var from = price.querySelector('.ds-pc__from');
      if (from) from.remove();
      if (now) now.textContent = btn.dataset.now;
      if (was) was.textContent = btn.dataset.was || '';
      price.classList.toggle('is-sale', !!btn.dataset.was);
    }

    var add = card.querySelector('[data-ds-add]');
    if (add && btn.dataset.id) {
      add.dataset.variant = btn.dataset.id;
      add.disabled = btn.dataset.available === 'false';
    }
  }

  /* ---------- Quick add ---------- */
  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function openDrawer() {
    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-cart-sidebar]'));
    var visible = openers.filter(function (el) { return el.offsetParent !== null; })[0];
    if (visible) { visible.click(); return true; }
    return false;
  }

  /* body: FormData from a product form, or { items: [{ id, quantity }] } */
  function addToCart(body) {
    var isForm = typeof FormData !== 'undefined' && body instanceof FormData;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: isForm ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      })
      .then(function (added) {
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCounts(cart.item_count);
            document.dispatchEvent(new CustomEvent('ds:cart:added', { detail: { cart: cart, added: added } }));
            return cart;
          });
      });
  }
  window.DSCore.addToCart = addToCart;
  window.DSCore.openCart = openDrawer;

  function quickAdd(btn) {
    var id = parseInt(btn.dataset.variant, 10);
    if (!id || btn.classList.contains('is-loading')) return;
    var label = btn.getAttribute('aria-label') || '';
    btn.classList.remove('is-added', 'is-error');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    addToCart({ items: [{ id: id, quantity: 1 }] })
      .then(function () {
        btn.classList.add('is-added');
        btn.setAttribute('aria-label', 'Added to cart');
        openDrawer();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.setAttribute('aria-label', label);
        }, 2000);
      })
      .catch(function (err) {
        btn.classList.add('is-error');
        btn.setAttribute('aria-label', err.message);
        btn.title = err.message;
        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.setAttribute('aria-label', label);
          btn.removeAttribute('title');
        }, 2500);
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  }

  /* ---------- Video lightbox (YouTube / Vimeo load only when tapped) ---------- */
  function openVideo(src, label) {
    var d = document.getElementById('DsVideoDialog');
    if (!d) {
      d = document.createElement('dialog');
      d.id = 'DsVideoDialog';
      d.className = 'ds-video';
      d.innerHTML = '<button type="button" class="ds-video__close" aria-label="Close video"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="ds-video__frame"></div>';
      document.body.appendChild(d);
      d.addEventListener('click', function (ev) {
        if (ev.target === d || ev.target.closest('.ds-video__close')) d.close();
      });
      d.addEventListener('close', function () { d.querySelector('.ds-video__frame').innerHTML = ''; });
    }
    var frame = document.createElement('iframe');
    frame.src = src;
    frame.title = label || 'Video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    d.querySelector('.ds-video__frame').replaceChildren(frame);
    if (typeof d.showModal === 'function') d.showModal(); else window.open(src, '_blank');
  }

  document.addEventListener('click', function (e) {
    var vid = e.target.closest('[data-ds-video]');
    if (vid) { e.preventDefault(); openVideo(vid.dataset.dsVideo, vid.getAttribute('aria-label')); return; }
    var sw = e.target.closest('.ds-sw');
    if (sw) { e.preventDefault(); pickSwatch(sw); return; }
    var add = e.target.closest('[data-ds-add]');
    if (add) { e.preventDefault(); quickAdd(add); }
  });
})();
